import React from 'react';
import { AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '../../hooks/useTheme';

const InsightCharts = ({ moodData, pomodoroSessions }) => {
  const { theme } = useTheme();

  // Prepare weekly mood data
  const weeklyMoodData = [];
  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const dayMoods = moodData.filter(m => 
      new Date(m.date).toDateString() === date.toDateString()
    );
    weeklyMoodData.push({
      day: date.toLocaleDateString('en', { weekday: 'short' }),
      mood: dayMoods.length > 0 
        ? parseFloat((dayMoods.reduce((acc, m) => acc + m.mood, 0) / dayMoods.length).toFixed(1))
        : 0
    });
  }

  // Prepare productivity data
  const productivityData = [];
  for (let i = 6; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const daySessions = pomodoroSessions.filter(s => 
      new Date(s.date).toDateString() === date.toDateString()
    );
    productivityData.push({
      day: date.toLocaleDateString('en', { weekday: 'short' }),
      sessions: daySessions.length
    });
  }

  return (
    <>
      {/* Mood Trend Chart */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Weekly Mood Trend</h3>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={weeklyMoodData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis domain={[0, 5]} ticks={[1, 2, 3, 4, 5]} />
            <Tooltip />
            <Area 
              type="monotone" 
              dataKey="mood" 
              stroke="#3B82F6" 
              fill="#93BBFC"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      {/* Productivity Chart */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Weekly Productivity</h3>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={productivityData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="sessions" fill="#10B981" name="Sessions" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default InsightCharts;